import React,{Fragment, useEffect, useState} from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import './SaveQuoteButton.scss';
import { TextInput } from "../../../Helpers/Inputs";
import ShieldCheckmarkIcon from '../../../../icons/shield-checkmark.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { object, string } from 'yup';
import { SaveQuoteLog } from "./SaveQuoteLog";
import Alert from "@material-ui/lab/Alert";
import { emptyStringToUndefined } from "../../../Helpers/Formatters/EmptyStringToUndefined";
import { getBasicInfo, getSessionStorageItem, SESSION_STORAGE_SAVED_QUOTE_DATA, } from '../../../../sessionStorage';

const white = "#ffffff";
const offWhite = "rgba(255, 255, 255, 0.7)";

const useStyles = makeStyles((theme) => ({
    white: {
        border: `2px solid ${white}`,
        '&:hover': {
            borderColor: offWhite
        },
        '&:focus': {
            boxShadow: `0 0 5px 0px ${offWhite}`,
            outline: 'none'
        }
    }
}));

export default function SaveQuoteAnalysis(props) {
    
    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [isSaveloading, setSaveLoading] = useState(false);
    const basicInfo = getBasicInfo();
    const saveQuoteData = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
    
    function handleClick() {
        props.fields.setErrorMessage({ status: '', message: '' });
        props.fields.setModalSaveQuoteIsOpen(false);
    };

    const { handleSubmit, setValue, register, errors, triggerValidation } = useForm({
        validationSchema: SaveQuoteAnalysis.ValidationSchema,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const newSaveQuoteData = {...props.saveQuoteData};

    useEffect(() => {
        if (saveQuoteData && !!saveQuoteData.quoteSaved) {
            setFirstName(saveQuoteData.firstName);
            setEmail(saveQuoteData.emailAddress);
        }
    }, [props.saveQuoteData, props.isQuoteSaved]);

    useEffect(() => {
        register({ name: 'isQuoteSaved' });
        setValue('isQuoteSaved', props.isQuoteSaved);
    }, [register]);

    useEffect(() => {
        basicInfo.email = email;
        basicInfo.firstName = firstName;
        newSaveQuoteData.emailAddress = email;
        newSaveQuoteData.firstName = firstName;
        const contact = {
            firstName: newSaveQuoteData.firstName,
            emailAddress: newSaveQuoteData.emailAddress,
        }
        props.handleContactChange(contact);
    }, [email, firstName]);


    const handleValueChange = (field, value) =>{
        if (field === "email") {
            setEmail(value);
        }
        if (field === "firstName") {
            const singleSpaceValue = value.replace(/\s+/g, " ");
            setFirstName(singleSpaceValue);
        }
        triggerValidation(field);
    };

    const handleSaveQuote = () => {
        setSaveLoading(true);
        props.fields.setErrorMessage({ status: '', message: '' });
        props.setEmailPrefill(basicInfo);
        SaveQuoteLog(newSaveQuoteData, setSaveLoading, props.fields.setErrorMessage, props.setQuoteSaved, props.saveMessage);  
    };

    return (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <p className={props.fields.errorMessage.status === "success" ? "save-term-text center" : "save-term-text" }>{props.fields.errorMessage.status === "success" ? props.saveMessage && props.saveMessage.success.message : props.saveMessage && props.saveMessage.initial.message}</p>
                    <Form onSubmit={handleSubmit(handleSaveQuote)}>
                    {!props.fields.errorMessage.status && 
                    <Fragment>
                        {!props.isQuoteSaved && 
                        <Fragment>
                            <Form.Group>
                                <TextInput
                                    name="firstName"
                                    id="firstName"
                                    label="First Name"
                                    value={firstName}
                                    onChange={(e) => handleValueChange("firstName", e.target.value)}
                                    errors={errors && errors.firstName}
                                    inputRef={register}
                                />
                            </Form.Group>
                            <Form.Group>
                                <TextInput
                                    name="email"
                                    id="email"
                                    label="Email"
                                    value={email}
                                    onChange={(e) => handleValueChange("email", e.target.value)}
                                    errors={errors && errors.email}
                                    inputRef={register}
                                />
                            </Form.Group>
                        </Fragment>
                        }
                        <Button
                            variant="contained"
                            color='primary'
                            size="large"
                            className='btn-wide-sm mb-2'
                            fullWidth={true}
                            type="submit"
                            disabled={props.fields.loading || isSaveloading}
                        >
                        {isSaveloading ? <CircularProgress size={25} /> :
                        <React.Fragment>
                            <SvgIcon component={ShieldCheckmarkIcon} className="mr-2" /> <b>{props.isQuoteSaved  ? "UPDATE SAVED QUOTE" : "SAVE MY QUOTE"}</b>
                        </React.Fragment>
                        }
                        </Button>
                    </Fragment>
                    }
                    </Form>
                    
                    { props.fields.errorMessage.message && 
                    <Row className="mt-2">
                        <Col >
                        { props.fields.errorMessage.status !== "success" &&
                        <Alert severity={props.fields.errorMessage.status} className="mb-2">
                            <div> {props.fields.errorMessage.message}</div>
                        </Alert>
                        }
                        </Col>
                    </Row>}
                    <Button
                        variant="outlined"
                        color='primary'
                        size="large"
                        onClick={() => handleClick()}
                        className={`btn-wide-sm ${classes.white}`}
                        fullWidth={true}
                    >
                        <b>{props.fields.errorMessage.status === "success" ? "BACK TO MY QUOTES" : props.isQuoteSaved ? "CONTINUE WITHOUT UPDATING" : "CONTINUE WITHOUT SAVING"}</b>
                    </Button>
                    { !props.isQuoteSaved && 
                        <p className="privacy-info">Your information is secure and confidential. We never sell your personal information.</p>
                    }
                </Col>
            </Row>
        </React.Fragment >
    )
}

SaveQuoteAnalysis.ValidationSchema = object().shape({
    firstName: string().transform(emptyStringToUndefined).when('isQuoteSaved', {
        is: true,
        then: string().notRequired(),
        otherwise: string()
            .required('First name is required'),
    }),    
    email :string().transform(emptyStringToUndefined).when('isQuoteSaved', {
        is: true,
        then: string().notRequired(),
        otherwise: string()
            .email('Enter a valid email')
            .required('Email is required'),
    }),
});


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/SaveTermQuote/SaveQuoteAnalysis.js